import { Toast } from './../../../../services'

export default {
  name: 'bonusCarbonTradeItem',
  props: {
    project: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  methods: {
    goToDetails() {
      this.$router.push('/tradeofco2/details/' + this.project._id)
    },
    tradeNow() {
      Toast.notImplemented({
        toast: this.$toast,
      })
    },
  },
}



// WEBPACK FOOTER //
// ./src/components/TradeOfCO2/TradeBoard/BonusCarbonTradeItem/BonusCarbonTradeItem.component.js